<ng-template #modalFooter>
  <div *ngIf="hasButtons" data-testid="modal-footer" class="modal-footer flex justify-content-around"
       [ngClass]="styles.light ? 'deep-orange-text' : 'text-white'">
    <button *ngIf="hasBackButton" pButton pRipple type="button" class="p-button-plain"
            [rounded]="true" [outlined]="true"
            [label]="backButtonLabel || ('common.button.back' | translate)"
            [disabled]="disableBackButton" (click)="backCallback($event)"></button>
    <button *ngIf="hasDismissButton" pButton pRipple type="button" class="p-button-plain"
            [rounded]="true" [outlined]="true" [label]="'common.button.dismiss' | translate"
            [disabled]="disableDismissButton" (click)="requestHide()"></button>
    <p-button *ngIf="hasResetButton" type="button" severity="danger"
              badgeClass="p-badge-contrast p-badge-md" [badge]="resetButtonBadge"
              [rounded]="true" [outlined]="true" [label]="'common.button.reset' | translate"
              (click)="emitReset($event); resetCallback($event)"></p-button>
    <p-button *ngIf="hasProceedButton" type="button" severity="primary"
              badgeClass="p-badge-contrast p-badge-md" [badge]="proceedButtonBadge"
              [rounded]="true" [outlined]="true"
              [label]="(btnSuccessName || 'common.button.proceed') | translate"
              [disabled]="btnDisabled" [loading]="loading" data-testid="modal-confirm" (click)="processAction()" loadingIcon="app-loading-ring"></p-button>
  </div>
</ng-template>

<p-dialog [showHeader]="isHeaderVisible" [header]="name" [visible]="visible" (visibleChange)="onDialogVisibleChange($event)"
          appMobileFocusManager [appendTo]="styles.mobileFullscreen ? 'body' : null"
          styleClass="app-modal {{styles.slideFrom}} {{styles.modalType}}"
          [style]="dialogStyle"
          [breakpoints]="isMobileFullscreenViewport || styles.mobileFullscreen === false ? {} : {'960px': '75vw', '640px': '100vw'}"
  [modal]="true" [closable]="!isCloseGuardedModal" [closeOnEscape]="!isCloseGuardedModal"
  [dismissableMask]="!isCloseGuardedModal" (onShow)="onDialogShow()" (onHide)="onDialogHide()">
  <ng-template pTemplate="header">
    <ng-container *ngIf="hasHeaderBackButton; else defaultHeader">
      <div class="app-modal__flow-header">
        <button type="button" pButton pRipple icon="pi pi-arrow-left"
                class="p-button-rounded p-button-text p-button-plain app-modal__flow-header-action"
                [disabled]="disableHeaderBackButton"
                [attr.aria-label]="'common.button.back' | translate"
                (click)="headerBackCallback($event)"></button>
        <h1 class="app-modal__flow-header-title">{{name}}</h1>
        <button *ngIf="isCloseGuardedModal" type="button" pButton pRipple icon="pi pi-times"
                class="p-button-rounded p-button-text p-button-plain app-modal__flow-header-action"
                [attr.aria-label]="'common.button.dismiss' | translate"
                (click)="headerCloseCallback ? headerCloseCallback($event) : requestHide()"></button>
        <span *ngIf="!isCloseGuardedModal" class="app-modal__flow-header-action"></span>
      </div>
    </ng-container>
    <ng-template #defaultHeader>
      <div class="grid grid-nogutter w-full relative pr-3">
        <div class="col-12"><h1 class="font-medium text-xl mb-0">{{name}}</h1></div>
        <button *ngIf="isCloseGuardedModal" type="button" pButton pRipple icon="pi pi-times"
                class="p-button-rounded p-button-text p-button-plain absolute"
                style="right: -0.5rem; top: 50%; transform: translateY(-50%);"
                (click)="requestHide()"></button>
      </div>
    </ng-template>
    <div class="absolute w-full top-0 left-0">
      <p-progressBar *ngIf="progress !== null" [styleClass]="'w-full'" [style]="{ height: '6px' }"
                     [value]="progress"/>
    </div>
  </ng-template>
  <ng-template appModal pTemplate="content"></ng-template>
  <p-footer><ng-container *ngTemplateOutlet="modalFooter"></ng-container></p-footer>
</p-dialog>
